import gql from 'graphql-tag';
import actionTypes from './constants';
// import helpers from './../../helpers';

/* */
export const searchMembers = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.SEARCH_MEMBERS}`,
  fetchPolicy,
  variables,
})
  .then((res) => res.data)
  .then((data) => ({ members: data.searchMembers }));

/* */
export const searchPartners = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.SEARCH_PARTNERS}`,
  fetchPolicy,
  variables,
})
  .then((res) => res.data)
  .then((data) => ({ partners: data.searchPartners }));

/* */
export const getContacts = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_CONTACTS}`,
  fetchPolicy,
  variables,
})
  .then((res) => res.data)
  .then((data) => ({ contacts: data.getContacts }));

/* */
export const setContact = (client, variables) => client.mutate({
  mutation: gql`${actionTypes.gql.SET_CONTACT}`,
  variables,
})
  .then((res) => res.data)
  .then((data) => ({ contact: data.setContact }));

/* */
export const deleteContact = (client, variables) => client.mutate({
  mutation: gql`${actionTypes.gql.DELETE_CONTACT}`,
  variables,
})
  .then(({ data }) => data.deleteContact);
